import React, { Component } from 'react';
import { withRouter  } from 'react-router-dom';
import ActionMenu from '../../utils/ActionMenu';
import { roleId } from '../../../constants/app';

class DevicesTable extends Component {
    renderAdress(item) {
        const point = item.point;
        const city = item.city || null;
        return `${city && city.name ? city.name : '---'}, ${point.street}, ${point.house}`;
    }

    handleDoubleClick = (id) => () => {
        this.props.history.push(`/cassa/devices/edit/${+id}`)
    }

    renderThead() {
        return (
            <thead className="kt-datatable__head">
                <tr className="kt-datatable__row">                    
                    <th className="kt-datatable__cell" style={{ width: '10%' }}>
                        <span>ID</span>
                    </th>
                    <th className="kt-datatable__cell" style={{ width: '30%' }}>
                        <span>Филиал</span>
                    </th>
                    <th className="kt-datatable__cell" style={{ width: '20%' }}>
                        <span>Хост</span>
                    </th>
                    <th className="kt-datatable__cell" style={{ width: '10%' }}>
                        <span>Порт</span>
                    </th>
                    <th className="kt-datatable__cell" style={{ width: '10%' }}>
                        <span>ФФД</span>
                    </th>
                    <th className="kt-datatable__cell" style={{ width: '10%' }}>
                        <span>deviceID</span>
                    </th>
                    <th className="kt-datatable__cell" align='right' width="80px">
                        <span>Действия</span>
                    </th>
                </tr>
            </thead>
        );
    }
    
    renderBody() {
        if (this.props.items.length === 0) {
            return (
                <div>Оборудование не найдено</div>
            );
        }

        return (
            <tbody className="kt-datatable__body">
                {
                    this.props.items.map((item, index) => {
                        const actions = [
                            { access: [roleId.admin, roleId.manager, roleId.regionalDirector, roleId.operationDirector], name: 'Редактирование', icon: 'flaticon2-contract', action: () => this.props.history.push(`/cassa/devices/edit/${item.id}`) },
                            { access: [roleId.admin, roleId.manager, roleId.regionalDirector, roleId.operationDirector], name: 'Удалить', icon: 'flaticon2-trash', action: () => this.props.onDelete(item.id) }
                        ].filter(item => !item.access || item.access.includes(this.props.role));
                        return (
                            <tr key={item.id} className="kt-datatable__row" onDoubleClick={this.handleDoubleClick(item.id)}>                            
                                <td className="kt-datatable__cell" style={{ width: '10%' }}>
                                    <span>{item.id}</span>
                                </td>
                                <td className="kt-datatable__cell" style={{ width: '30%' }}>
                                    <span>{this.renderAdress(item)}</span>
                                </td>
                                <td className="kt-datatable__cell" style={{ width: '20%' }}>
                                    <span>{item.host || '---'}</span>
                                </td>
                                <td className="kt-datatable__cell" style={{ width: '10%' }}>
                                    <span>{item.port || '---'}</span>
                                </td>
                                <td className="kt-datatable__cell" style={{ width: '10%' }}>
                                    <span>{item.ffd || '---'}</span>
                                </td>
                                <td className="kt-datatable__cell" style={{ width: '10%' }}>
                                    <span>{item.deviceId || '---'}</span>
                                </td>
                                <td className="kt-datatable__cell" align='right' width="80px">
                                    <ActionMenu actions={actions}/>
                                </td>
                            </tr>
                        );
                    }) 
                }
            </tbody>
        );
    }

    render() {
        return (
            <table className="kt-datatable__table" style={{ minHeight: '500px' }}>
                {this.renderThead()}
                {this.renderBody()}
            </table>
        );
    }
}

export default withRouter(DevicesTable);